module.exports = __webpack_public_path__ + "static/langojango-hungarian-language-phrasebook-b52a711bda188044c526f55a732b4290.png";